import React from 'react'
import { Container, Grid, Button, Typography, Box, List, Rating , ListItem } from '@mui/material';
import RecyclingIcon from '@mui/icons-material/Recycling';
import SchoolIcon from '@mui/icons-material/School';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import { Link } from 'react-router-dom';
import {useTheme, useMediaQuery } from '@mui/material';
import bg from "../assests/images/New-Project-5.jpg"
import bg1 from "../assests/images/Z6A2937.jpg"
import hat from "../assests/images/hat.png"
import plate from "../assests/images/plate.png"
import list from "../assests/images/list.png"
import pan from "../assests/images/pan.png"
import img1 from "../assests/images/sandwich.jpg"
import img2 from "../assests/images/meal.jpg"
import img3 from "../assests/images/burger2.jpg"
import img4 from "../assests/images/pasta2.jpg"
import img5 from "../assests/images/potato.jpg"
import img6 from "../assests/images/bread.jpg"
import img7 from "../assests/images/croissants5.jpg"
import img8 from "../assests/images/samboli.jpg"
import img9 from "../assests/images/dd.jpg"
import img10 from "../assests/images/nh.jpg"
import { GoChecklist } from "react-icons/go";
import { GiChefToque } from "react-icons/gi";
import { useDBPosts  } from '../contexts/DBPostsContext'; // Import PostContext
import { BsRecycle } from "react-icons/bs";
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

export default function Services() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <div>
         <Grid 
         container 
         component="main" 
         
         sx={{
            backgroundImage: `url(${bg1})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
        
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'ceter',
            padding: isSmUp? '2rem 4rem' : "2rem 2rem" 


          }}

      >

         {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#182427',
          opacity: 0.3,
          zIndex: 1,
        }}
      />

        <Grid
        item
        xs ={12}
        md={12}
        sx={{
          
            zIndex: 2,
            padding:3
        }}

        >
            <Typography component="h2" variant="h2" align="center"  className='sub-heading' style={{color: 'white', fontWeight: '600'}} >
          My Services      
        </Typography>

             </Grid>
             </Grid>

             
             <Grid 
      container 
      component="main" 
      
      sx={{

        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 
      }}
    >
    

     

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={12} 
        component={Box} 
        sx={{ 
          zIndex: 2, // Ensure content is on top of overlay
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          padding: 3 
        }}
      >
        <Grid marginBottom="3rem">

        <Typography component="h6" variant="h6" align="center" mb={1} className='heading' >
        Offered Services
        </Typography>
        <Typography component="h3" variant="h3" align="center" mb={1} className='sub-heading'>
        Providing Exceptional Service Creating <br/> Remarkable Dishes
       
        </Typography>
        </Grid>

        <Grid
        container
        component={Box}
        
        sx={{
          
            display: 'flex',
            
            justifyContent: 'center',
            alignItems: 'center',

        }}
        >

       
        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={6} 
            sx={{
                display: 'flex',
                flexDirection: 'column',
             alignItems: 'start',
             padding: isSmUp ? '0 2rem' : ''

            
            }}
        >
        <img src={pan} style={{width:'100px'}} alt="" />
        <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
        Menu Development & Culinary Innovation
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        A great menu is the heart of every successful restaurant. With my experience across Italian, French, Middle Eastern, and Turkish cuisines, I specialize in developing menus that not only excite your customers but also maximize profitability. From traditional dishes with a modern twist to creating entirely new concepts, I’ll work with you to craft a menu that sets your restaurant apart        </Typography>
        </Grid>

        <Grid
             container 
             xs={12} 
             sm={12} 
             md={6} 

         
               sx={{
                   display: 'flex',
                       padding: isSmUp ? '0 2rem' : '',
                    marginY : !isSmUp ? '2rem' : '',
               }} 

        >
            <Grid
            container 
            xs={12} 
            sm={12} 
            md={6} 
            sx={{
                display: 'flex',
             
        
            }} 
            
            >

                <img src={img1} style={{width: '250px'}}   alt="" />
            </Grid>

            <Grid
            container 
            xs={12} 
            sm={12} 
            md={6} 
                sx={{
                display: 'flex',
         
        
            }} 
            >

                <img src={img2} style={{width: '250px', marginTop: '8%'}}   alt="" />
            </Grid>

        </Grid>
        
       
       <>

        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={6} 
            sx={{
                display: 'flex',
                flexDirection: 'column',
             alignItems: 'start',
                 padding: isSmUp ? '0 2rem' : ''

            
            }}
        >
        <img src={list} style={{width:'100px'}} alt=""  />
        <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
        Restaurant Consulting & Management
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        Struggling to take your restaurant to the next level? I provide expert restaurant consulting services, focusing on maximizing profits, reducing waste, and optimizing operations. With over 13 years of experience, I can help your restaurant thrive, whether it’s by creating an innovative menu or training your staff to excel. Let’s transform your business into a culinary success story.        
        </Typography>
        </Grid>

        <Grid
             item 
             xs={12} 
             sm={12} 
             md={6} 
         
               sx={{
                   display: 'flex',
                 padding: isSmUp ? '0 2rem' : '',
                   marginY: '1%'
           
               }} 

        >
            <Grid
            item 
            xs={12} 
            sm={12} 
            md={12} 
            sx={{
                display: 'flex',
              justifyContent: 'center',
              marginY : !isSmUp ? '2rem' : '',
        
            }} 
            
            >

                <img src={img4} style={{width: '250px',  marginTop: '8%'}}   alt="" />
            </Grid>

        

        </Grid>

        </>

        <>

        <Grid 
          item 
          xs={12} 
          sm={12} 
          md={6} 
            sx={{
                display: 'flex',
                flexDirection: 'column',
            alignItems: 'start',
        padding: isSmUp ? '0 2rem' : ''

            
            }}
        >
        <img src={hat} style={{width:'100px'}} alt="" />
        <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
        Comprehensive Staff Training & Development
        </Typography>
        <Typography component="p" variant="p" align="start"  className='body'>
        Your team is the backbone of your restaurant’s success. I offer hands-on staff training to improve skills, efficiency, and customer service. From kitchen staff to front-of-house teams, I ensure your employees are equipped with the knowledge and expertise to meet the highest standards of culinary excellence and hospitality.        </Typography>
        </Grid>

        <Grid
            item 
            xs={12} 
            sm={12} 
            md={6} 
        
              sx={{
                  display: 'flex',
                  padding: '0 2rem',
                  marginY: '1%'
          
              }} 

        >
            <Grid
            item 
            xs={12} 
            sm={12} 
            md={12} 
            sx={{
                display: 'flex',
              justifyContent: 'end',
              marginY : !isSmUp ? '2rem' : '',
            }} 
            
            >

                <img src={img3} style={{width: '250px',  marginTop: '8%'}}   alt="" />
            </Grid>

            



        </Grid>

        </>

        <>

            <Grid 
              item 
              xs={12} 
              sm={12} 
              md={6} 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                alignItems: 'start',
               padding: isSmUp ? '0 2rem' : ''

                
                }}
            >
             <BsRecycle className='icon' />
            <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
            Waste Reduction & Profit Maximization Solution
            </Typography>
            <Typography component="p" variant="p" align="start"  className='body'>
            In today's competitive restaurant industry, managing costs is crucial to success. I specialize in implementing waste reduction strategies that reduce loss and increase profit. My techniques have been proven to lower waste rates to below 0%, allowing restaurants to save money and become more sustainable. Let me help you turn your kitchen waste into revenue and streamline your operations for greater profitability.            
            
            </Typography>
            </Grid>

            <Grid
                item 
                xs={12} 
                sm={12} 
                md={6} 

                  sx={{
                      display: 'flex',
                      padding: '0 2rem',
                      marginY: '1%'
              
                  }} 

            >
                <Grid
                item 
                xs={12} 
                sm={12} 
                md={12} 
               
                sx={{
                    display: 'flex',
                  justifyContent: 'start',
                  marginY : !isSmUp ? '2rem' : '',

                }} 
                
                >

                    <img src={img5} style={{width: '250px',  marginTop: '8%', marginLeft: '10%'}}   alt="" />
                </Grid>

                



            </Grid>

            </>

            <>

            <Grid 
              item 
              xs={12} 
              sm={12} 
              md={6} 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                alignItems: 'start',
         padding: isSmUp ? '0 2rem' : ''

                
                }}
            >
            <GoChecklist  className='icon' />

            <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
            Exclusive Culinary Workshops & Masterclasses
            </Typography>
            <Typography component="p" variant="p" align="start"  className='body'>
            Looking to elevate your culinary skills or train your team in specific cuisines? I offer in-depth culinary workshops and masterclasses, where I teach everything from Italian and French techniques to advanced baking skills. Whether you're an aspiring chef or a restaurant owner looking to train your staff, my hands-on classes provide the knowledge and expertise needed to succeed.
            </Typography>
            </Grid>

            <Grid
                item 
                xs={12} 
                sm={12} 
                md={6} 

                  sx={{
                      display: 'flex',
                      padding: '0 2rem',
                      marginY: '1%'
              
                  }} 

            >
                <Grid
                item 
                xs={12} 
                sm={12} 
                md={12} 
              
                sx={{
                    display: 'flex',
                  justifyContent: 'center',
                  marginY : !isSmUp ? '2rem' : '',

                }} 
                
                >

                    <img src={img8} style={{width: '250px',  marginTop: '8%'}}   alt="" />
                </Grid>

                



            </Grid>

            </>


            <>

            <Grid 
              item 
              xs={12} 
              sm={12} 
              md={6} 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                alignItems: 'start',
               padding: isSmUp ? '0 2rem' : '',

                
                }}
            >
                <RestaurantMenuIcon className='icon' />
            <Typography component="h5" variant="h5" mb={1} align="start" mt={2} className='sub-heading'>
            Luxury Event & Buffet Catering
            
            </Typography>
            <Typography component="p" variant="p" align="start"  className='body'>
            Make your next event unforgettable with my luxury catering services. Whether you're planning a wedding, corporate event, or private party, I offer bespoke buffet and event catering tailored to your vision. From intimate gatherings to large-scale events, my menus and presentations will exceed your expectations and leave your guests raving.            </Typography>
            </Grid>

            <Grid
             container 
             xs={12} 
             sm={12} 
             md={6} 
         
               sx={{
                   display: 'flex',
                   padding: '0 2rem',
           
               }} 

        >
            <Grid
            item 
            xs={12} 
            sm={12} 
            md={6} 
            sx={{
                display: 'flex',
                marginY : !isSmUp ? '2rem' : '',
        
            }} 
            
            >

                <img src={img9} style={{width: '250px'}}   alt="" />
            </Grid>

            <Grid
            item 
            xs={12} 
            sm={12} 
            md={6} 
                sx={{
                display: 'flex',
                marginY : !isSmUp ? '2rem' : '',
        
            }} 
            >

                <img src={img10} style={{width: '250px'}}   alt="" />
            </Grid>

        </Grid>

            </>

        </Grid>
        


       
      </Grid>
    </Grid>

   
    <Grid
      container
      component="main"
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        paddingY: { xs: '2rem', sm: '3rem' },
        paddingX: !isSmUp ? '2rem' : '',
        backgroundAttachment: 'fixed',
        zIndex: 0,
        position: 'relative',
        marginY: '10%',
      }}
    >
      {/* Background Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#182427',
          opacity: 0.3,
          zIndex: 1,
        }}
      />

      {/* Main Content */}
      <Grid
        item
        xs={12}
        md={12}
        sx={{
          marginTop: { xs: '2%', md: '3%' },
          marginBottom: { xs: '5%', md: '13%' },
          zIndex: 2,
          textAlign: 'center',
          color: 'white',
          paddingX: { xs: '1rem', sm: '2rem' },
        }}
      >
        <Typography
          component="h6"
          variant="h6"
          align="center"
          mb={1}
          className="heading"
          sx={{
            color: 'white',
            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
            textTransform: 'uppercase',
          }}
        >
          Three Steps For Success
        </Typography>

        <Typography
          component="h3"
          variant="h3"
          align="center"
          mb={1}
          className="sub-heading"
          sx={{
            color: 'white',
            fontWeight: 800,
            fontSize: { xs: '1.8rem', sm: '2rem', md: '2.5rem' },
          }}
        >
          I Will Help You Every Step Of The Way
        </Typography>

        <Typography
          component="p"
          variant="body1"
          align="center"
          mt={3}
          className="body"
          sx={{
            color: 'white',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            maxWidth: '800px',
            margin: '0 auto',
          }}
        >
          Let’s take the first step together and build your culinary presence.
        </Typography>
      </Grid>

      {/* Steps Section */}
      <Grid
        container
        item
        xs={12}
        md={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          zIndex: 3,
          position: 'relative', // Changed from absolute to relative
          width: '100%',
          paddingX: { xs: '1rem', sm: '2rem' },
        }}
      >
        {/* Step 1 */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: '1rem', sm: '2rem' },
            borderLeft: { xs: 'none', md: '2px solid gold' },
            backgroundColor: 'white',
            marginBottom: { xs: '1rem', md: '0' },
            boxShadow: { xs: 1, md: 3 },
            borderRadius: '8px',
          }}
        >
          <Typography
            component="h6"
            variant="h6"
            align="start"
            mb={1}
            className="heading-card"
            sx={{
              fontWeight: 600,
              color: '#ca7735',
              fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' },
            }}
          >
            01
          </Typography>

          <Typography
            component="h5"
            variant="h5"
            align="start"
            mb={2}
            className="sub-heading-card"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
            }}
          >
            In-Depth Consultation & Assessment
          </Typography>

          <Typography
            component="p"
            variant="body1"
            align="start"
            className="body"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              color: '#555',
            }}
          >
            Before we begin, I’ll work closely with you to understand your vision, evaluate your restaurant’s current position, and identify key areas for improvement. This tailored approach ensures that the strategies we implement are aligned with your goals and the unique demands of your business.
          </Typography>
        </Grid>

        {/* Step 2 */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: '1rem', sm: '2rem' },
            borderLeft: { xs: 'none', md: '2px solid gold' },
            backgroundColor: 'white',
            marginX: { xs: 'none', md: '1rem' },
            marginBottom: { xs: '1rem', md: '0' },
            boxShadow: { xs: 1, md: 3 },
            borderRadius: '8px',
          }}
        >
          <Typography
            component="h6"
            variant="h6"
            align="start"
            mb={1}
            className="heading-card"
            sx={{
              fontWeight: 600,
              color: '#ca7735',
              fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' },
            }}
          >
            02
          </Typography>

          <Typography
            component="h5"
            variant="h5"
            align="start"
            mb={2}
            className="sub-heading-card"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
            }}
          >
            Crafting a Winning Game Plan
          </Typography>

          <Typography
            component="p"
            variant="body1"
            align="start"
            className="body"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              color: '#555',
            }}
          >
            With a clear understanding of your business, I’ll create a comprehensive strategy, from menu development and cost calculation to staff training and waste reduction. Every element will be optimized to drive profitability, operational efficiency, and customer satisfaction.
          </Typography>
        </Grid>

        {/* Step 3 */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: '1rem', sm: '2rem' },
            borderLeft: { xs: 'none', md: '2px solid gold' },
            backgroundColor: 'white',
            boxShadow: { xs: 1, md: 3 },
            borderRadius: '8px',
          }}
        >
          <Typography
            component="h6"
            variant="h6"
            align="start"
            mb={1}
            className="heading-card"
            sx={{
              fontWeight: 600,
              color: '#ca7735',
              fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' },
            }}
          >
            03
          </Typography>

          <Typography
            component="h5"
            variant="h5"
            align="start"
            mb={2}
            className="sub-heading-card"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
            }}
          >
            Implement, Optimize & Scale
          </Typography>

          <Typography
            component="p"
            variant="body1"
            align="start"
            className="body"
            sx={{
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              color: '#555',
            }}
          >
            Now it’s time to bring the plan to life. Together, we’ll implement the strategies, ensuring flawless execution, continuous optimization, and the ability to scale as your restaurant grows. My goal is to make your business not only successful but sustainable in the long run.
          </Typography>
        </Grid>
      </Grid>
    </Grid>

       {/* Call to Action */}
  <Grid item sm={12} textAlign="center" sx={{ marginY: '2%' ,  paddingX: !isSmUp ? '2rem' : '',}}>
    
  <Typography component="h6" sx={{ marginTop: '1rem', fontSize: '1.3rem', color: '#666' }}>
    Ready to Take the First Step?
    </Typography>

    <Typography component="p" sx={{ marginTop: '1rem', marginBottom: '1rem', fontSize: '1rem', color: '#666' }}>
     Get your free consultation & let’s discuss how we can elevate your business together!
    </Typography>

   
          <Link to="/contact"  my={2}  class="button-48" role="button"><span class="text"> Book free consultation</span></Link>
          


  </Grid>
    </div>
  )
}
